import React, { Component } from "react";
import { convertCurrency } from "../../utils";
import {
  getCustomerDetail,
  disableCardNumber,
} from "../../api";
import CardDetail from "../CardDetail/CardDetail";
import './Card.scss';
import CartPopup from "../CartPopup/CartPopup"
import { config, PRODUCT_IDS } from "../../Constants";
import { getCardStrategy } from "../../strategies/cardStrategies";

export class Card extends Component {
  constructor(props) {
    super(props);
    this.strategy = getCardStrategy(props.product.id);
    this.state = {
      product: props.product,
      price: 0,
      rechargeValue: this.strategy.getDefaultRecharge(props.product.id),
      customer: null,
      beneficiaries: [],
      open: false,
      quantity: 0,
      desactive: true,
      isReusablePopupOpen : false,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.strategy.fetchBeneficiaries().then((beneficiaries) => {
      if (beneficiaries.length > 0) {
        beneficiaries = beneficiaries.map((obj) => ({
          ...obj,
          readOnly: true,
          selected: false,
          rechargeValue: obj.rechargeValue || this.strategy.getDefaultRecharge(this.state.product.id),
        }));
        this.setState({ beneficiaries });
      }
    });

    getCustomerDetail().then((customer) => this.setState({ customer }, this.handlePriceChange()));
  }

  handleChange(e, isString = false) {
    if (!isNaN(parseInt(e.target.value)) || isString) {
      this.setState(
        {
          [e.target.name]: [e.target.value],
        },
        () => {
          this.handlePriceChange();
        }
      );
    }
  }
 
  setDesactive () {
    let desactive = this.state.desactive;
    this.setState({ desactive:!desactive });
  }
  addBeneficiaries(e, index) {
    const { name, value } = e.target;
    const list = [...this.state.beneficiaries.filter((beneficiary)=>beneficiary.status=="1")];
    list[index]['error']=false;
    if (name === "cardNumber") {
      list[index]["errorCard"] = '';
      // Check for duplicate card numbers across ALL active beneficiaries (excluding current one being edited)
      const currentBeneficiary = list[index];
      const isDuplicate = this.state.beneficiaries.some((beneficiary) => 
        beneficiary.status === "1" && 
        value === beneficiary.cardNumber && 
        beneficiary !== currentBeneficiary &&
        value !== ""
      );
      
      if (isDuplicate) {
        list[index]["errorCard"] = "Ce numéro CIN existe déjà";
      } else if (value.length !== 8 && value.length > 0) {
        list[index]["errorCard"] = "Votre CIN doit contenir 8 chiffres";
      }
      list[index][name] = value;
    }
    else if (name ==="cardName")
    { list[index]["errorName"] = '';
      if (value === "") {
        list[index]["errorName"] = "Votre nom ne doit pas etre vide";
      }
      list[index][name] = value;
    } else if (name === "rechargeValue") {
      list[index]["errorRecharge"] = '';
      const trimmedValue = value.trim();
      const numericValue = trimmedValue === "" ? 0 : parseFloat(trimmedValue);
      
      if (!this.strategy.validateRecharge(numericValue) && trimmedValue !== "") {
        list[index]["errorRecharge"] = this.strategy.getRechargeErrorMessage();
      }
      list[index][name] = numericValue;
    } else {
      list[index][name] = value;
      list[index]["errorName"]="";
      list[index]["errorCard"]="";
      list[index]["errorRecharge"]="";
    }
    this.setState({
      ...this.state.beneficiaries ,...list
    }, () => {
      this.handlePriceChange();
    });
  
  }

  addNewBeneficiary() {
    const { beneficiaries } = this.state;
    const newBeneficiaries = [
      ...beneficiaries,
      { 
        cardName: "", 
        cardNumber: "", 
        status :"1",
        selected: true,
        error:true,
        rechargeValue: this.strategy.getDefaultRecharge(this.state.product.id),
        errorRecharge: ""
      },
    ];

    this.setState({ beneficiaries: newBeneficiaries, desactive: true }, () =>
      this.handlePriceChange()
    );
  }

  removeNewBeneficiary(e, index) {
    
    const list = [...this.state.beneficiaries.filter((beneficiary)=>beneficiary.status=="1")];
    list[index].selected=false;
    list.splice(index, 1);
    this.setState({ beneficiaries: list },this.handlePriceChange());
    
  }
  disableBeneficiaries = async (e, filteredIndex) => {
    const { beneficiaries, desactive } = this.state;

    const filteredBeneficiaries = beneficiaries.filter(
      (beneficiary) => beneficiary.status === (+desactive).toString()
    );
    const beneficiary = filteredBeneficiaries[filteredIndex];

    if (beneficiary && beneficiary.readOnly) {
      try {
        const res = await disableCardNumber({
          cardNumber: beneficiary.cardNumber,
          status: (+!desactive).toString(),
        });

        if (res.success) {
          this.setState(prevState => ({
            beneficiaries: prevState.beneficiaries.map((b, i) =>
              b === beneficiary ? { ...b, status: (+!desactive).toString(), selected: false } : b
            ),
          }), () => {
            this.handlePriceChange();
          });
        } else {
          alert("Réessayer plus tard");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Une erreur est survenue. Veuillez réessayer plus tard.");
      }
    }
  };

  selectBeneficiaries = (e, index) => {
    const { checked } = e.target;
    const { beneficiaries } = this.state;

    const statusOneBeneficiaries = beneficiaries.filter(beneficiary => beneficiary.status === "1");

    if (index >= 0 && index < statusOneBeneficiaries.length) {
      const updatedBeneficiaries = [...beneficiaries];

      const indexOfBeneficiary = beneficiaries.indexOf(statusOneBeneficiaries[index]);
      updatedBeneficiaries[indexOfBeneficiary].selected = checked;
      
      const beneficiary = updatedBeneficiaries[indexOfBeneficiary];
      const hasRechargeError = this.strategy.requiresRechargeForSelection && 
        (!beneficiary.rechargeValue || beneficiary.rechargeValue < this.strategy.minRechargeValue);
      
      updatedBeneficiaries[indexOfBeneficiary].error = checked && (
        beneficiary.cardNumber === "" ||
        beneficiary.cardName === "" ||
        hasRechargeError
      );

      this.setState({ beneficiaries: updatedBeneficiaries }, () => {
        this.handlePriceChange();
      });
    }
  };

  selectAllBeneficiaries() {
    let { beneficiaries } = this.state;
    beneficiaries.filter((beneficiary)=>beneficiary.status=="1").map((beneficiary, i) =>
      beneficiary.selected = true
    );
    this.setState({ beneficiaries },this.handlePriceChange());
  }
    
  

  handlePriceChange() {
    let { beneficiaries } = this.state;
    beneficiaries = beneficiaries.filter((beneficiary) => beneficiary.selected);
    const totalPrice = this.strategy.calculatePrice(beneficiaries);
    this.setState({
      price: totalPrice,
      quantity: beneficiaries.length
    });
  }



 /* checkPhone(arr) {
    return arr.some(
      (beneficiary) =>
        beneficiary.phoneNumber.length !== 8
    );
  } */
  emptyFields(arr) {
    return arr.some(
      (beneficiary) =>
        beneficiary.cardName === "" || 
        beneficiary.cardNumber === "" || 
        (this.strategy.validateRechargeInEmptyFields && 
          (!beneficiary.rechargeValue || beneficiary.rechargeValue < this.strategy.minRechargeValue))
    );
  }
  setOpen() {

    this.setState({ open: !this.state.open })
  }
  checkCIN(arr) {
    return arr.some(
      (beneficiary) =>
        beneficiary.cardNumber.length !== 8
    );
  }

  addToCart() {
    let { beneficiaries, price, product } = this.state;
    
    // Get all active beneficiaries (status "1") to check for duplicates across the entire list
    const allActiveBeneficiaries = this.state.beneficiaries.filter((beneficiary) => beneficiary.status === "1");
    
    // Check for duplicate card numbers across ALL active beneficiaries (not just selected ones)
    const allCardNumbers = allActiveBeneficiaries.map(b => b.cardNumber).filter(num => num !== "");
    const uniqueCardNumbers = new Set(allCardNumbers);
    if (allCardNumbers.length !== uniqueCardNumbers.size) {
      const duplicates = allCardNumbers.filter((num, index) => allCardNumbers.indexOf(num) !== index);
      alert(`Des numéros CIN en double ont été détectés: ${[...new Set(duplicates)].join(', ')}`);
      return false;
    }
    
    // Now filter only selected beneficiaries for the cart
    beneficiaries = beneficiaries.filter((beneficiary) => beneficiary.selected);
    if (beneficiaries.length === 0) {
      alert("Merci de selectionner au moin 1 beneficiare");
      return false;
    }
    if (this.emptyFields(beneficiaries)) {
      alert("Merci de renseigner tous les champs");
      return false;
    }
    if (this.checkCIN(beneficiaries)) {
      alert("votre CIN doit contenir 8 chiffres")
      return false;
    }

    // Check for invalid recharge values
    if (this.strategy.validateRechargeInEmptyFields && 
        beneficiaries.some(b => !this.strategy.validateRecharge(b.rechargeValue))) {
      alert("Toutes les valeurs de recharge doivent être supérieures à 2");
      return false;
    }
    
   /* if (this.checkPhone(beneficiaries)) {
      alert("votre numéro de téléphone n'est pas valide")
      return false;
    } */

    const addUrl =  document.getElementById("add-to-cart-or-refresh")?.value || `${config.url}/panier`;
    const token = (process.env.REACT_APP_STAGE==='dev')?"6201c3c0310244f2bcffdda74673397a":document.getElementsByName("token")[0].value;

    const data = new FormData();
    data.append("token", token);
    data.append("id_product", product.id);
    data.append("qty", beneficiaries.length);
    data.append("beneficiaries", JSON.stringify(beneficiaries));
    data.append("total", price);
    data.append("add", 1);
    data.append("action", "update");

    const postToCart = async () => {
      const response = await fetch(addUrl, {
        method: "POST",
        mode: "cors",
        body: data,
      });
      return response;
    };

    postToCart().then(()=>this.setOpen());
  
  }
  handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = this.strategy.csvTemplateUrl;
    link.download = this.strategy.csvTemplateFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        const rows = text.split('\n').map(row => row.split(','));
        const headers = rows[0];
        const dataRows = rows.slice(1).filter(row => row.length > 1 && row.some(cell => cell.trim() !== ''));
        const updatedBeneficiaries = [...this.state.beneficiaries];
        const newBeneficiaries = [];
        const processedCardNumbers = new Set();
        
        dataRows.forEach((row) => {
          const rechargeValueStr = row[2] ? row[2].trim() : "";
          const rechargeValue = rechargeValueStr === "" ? 0 : parseFloat(rechargeValueStr) || 0;
          const cardNumber = row[1] ? row[1].trim() : "";
          const cardName = row[0] || "";
          
          // Skip if this card number was already processed in this CSV file
          if (processedCardNumbers.has(cardNumber) && cardNumber !== "") {
            return; // Skip duplicate within the same CSV
          }
          processedCardNumbers.add(cardNumber);
          
          // Find existing beneficiary with same card number
          const existingIndex = updatedBeneficiaries.findIndex(b => b.cardNumber === cardNumber && b.status === "1");
          
          if (existingIndex !== -1) {
            // Update existing beneficiary's recharge value and select them if valid
            if (this.strategy.validateRecharge(rechargeValue)) {
              updatedBeneficiaries[existingIndex].rechargeValue = rechargeValue;
              updatedBeneficiaries[existingIndex].errorRecharge = "";
              updatedBeneficiaries[existingIndex].selected = true;
              updatedBeneficiaries[existingIndex].error = false;
            } else {
              updatedBeneficiaries[existingIndex].errorRecharge = this.strategy.getRechargeErrorMessage();
              updatedBeneficiaries[existingIndex].error = true;
            }
          } else {
            // Create new beneficiary
            const beneficiary = {
              cardName: cardName,
              cardNumber: cardNumber,
              rechargeValue: rechargeValue,
              status: "1",
              selected: true,
              error: false,
              errorCard: "",
              errorName: "",
              errorRecharge: "",
              readOnly: false,
            };
            
            let hasError = false;
            
            if (cardNumber.length !== 8) {
              beneficiary.errorCard = "Votre CIN doit contenir 8 chiffres";
              hasError = true;
            }
    
            if (cardName === "") {
              beneficiary.errorName = "Votre nom ne doit pas etre vide";
              hasError = true;
            }

            if (this.strategy.validateRechargeInEmptyFields && !this.strategy.validateRecharge(rechargeValue)) {
              beneficiary.errorRecharge = this.strategy.getRechargeErrorMessage();
              hasError = true;
            }
            
            beneficiary.error = hasError;
            
            newBeneficiaries.push(beneficiary);
          }
        });
  
        this.setState({
          beneficiaries: [...updatedBeneficiaries, ...newBeneficiaries]
        }, this.handlePriceChange);
      };
      reader.readAsText(file);
    }
  };
  
  

  render() {
    const { product, price, beneficiaries, desactive } = this.state;
    
    return (
      <div className="Card">
        <h1>{product.name}</h1>
        <p className="desc">
          {product.description_short.replace(/<[^>]*>?/gm, "")}
        </p>
        <p className="price">{convertCurrency(price)}</p>
        <div className="beneficiaries">
          <div id="label_beneficiaires">
            <label htmlFor="couponName">Selectionnez les bénéficiaires :</label>
          </div>
          <div
            style={{
              flexFlow: "row",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
            className="add_ben input-group"
          >
            <button
              className="button-round white same-line"
              onClick={() => this.selectAllBeneficiaries()}
            >
              <span>+</span> Tout selectionner
            </button>
            <button
              className="button-round white same-line"
              style={{ marginRight: "10px" }}
              onClick={() => this.addNewBeneficiary()}
            >
              <span>+</span> Ajouter un nouveau bénéficiaires
          </button>
          
         <button className="button-round white same-line" onClick={() => this.setDesactive()}>
         { (desactive) ?
            (<span>bénéficiaires désactivés</span>)
          : (<span>bénéficiaires activés</span> )
         }
         </button> 
         <div style={{display: "flex",alignItems: "center",flexDirection: "row",marginLeft:"2px"}}>
         <button className="button-round white same-line" onClick={() => this.fileInputRef.current.click()}>
              <span>+</span> Importer bénéficiaires
          </button>
          <a className="csv" href={this.strategy.csvTemplateUrl} download={this.strategy.csvTemplateFilename}>
              <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" height="30" width="30" fill="#000000" stroke="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title></title> <g id="xxx-word"> <path style={{fill:'#FF3E3E'}} d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"></path> <path style={{fill:'#FF3E3E'}} d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"></path> <path style={{fill:'#FF3E3E'}} d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"></path> <path style={{fill:'#FF3E3E'}} d="M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z"></path> <path style={{fill:'#FF3E3E'}} d="M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z"></path> <path style={{fill:'#FF3E3E'}} d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"></path> <path style={{fill:'#FF3E3E'}} d="M168.48,217.48l8.91,1a20.84,20.84,0,0,1-6.19,13.18q-5.33,5.18-14,5.18-7.31,0-11.86-3.67a23.43,23.43,0,0,1-7-10,37.74,37.74,0,0,1-2.46-13.87q0-12.19,5.78-19.82t15.9-7.64a18.69,18.69,0,0,1,13.2,4.88q5.27,4.88,6.64,14l-8.91.94q-2.46-12.07-10.86-12.07-5.39,0-8.38,5t-3,14.55q0,9.69,3.2,14.63t8.48,4.94a9.3,9.3,0,0,0,7.19-3.32A13.25,13.25,0,0,0,168.48,217.48Z"></path> <path style={{fill:'#FF3E3E'}} d="M179.41,223.15l9.34-2q1.68,7.93,12.89,7.93,5.12,0,7.87-2a6.07,6.07,0,0,0,2.75-5,7.09,7.09,0,0,0-1.25-4q-1.25-1.85-5.35-2.91l-10.2-2.66a25.1,25.1,0,0,1-7.73-3.11,12.15,12.15,0,0,1-4-4.9,15.54,15.54,0,0,1-1.5-6.76,14,14,0,0,1,5.31-11.46q5.31-4.32,13.59-4.32a24.86,24.86,0,0,1,12.29,3,13.56,13.56,0,0,1,6.89,8.52l-9.14,2.27q-2.11-6.05-9.84-6.05-4.49,0-6.86,1.88a5.83,5.83,0,0,0-2.36,4.77q0,4.57,7.42,6.41l9.06,2.27q8.24,2.07,11.05,6.11a15.29,15.29,0,0,1,2.81,8.93,14.7,14.7,0,0,1-5.92,12.36q-5.92,4.51-15.33,4.51a28,28,0,0,1-13.89-3.32A16.29,16.29,0,0,1,179.41,223.15Z"></path> <path style={{fill:'#FF3E3E'}} d="M250.31,236h-9.77L224.1,182.68h10.16l12.23,40.86L259,182.68h8Z"></path> </g> </g></svg>
          </a>
         
          </div>

          </div>
          <input
              type="file"
              accept=".csv, .xlsx"
              style={{ display: 'none' }}
              ref={this.fileInputRef}
              onChange={this.handleFileUpload}
            />

          {/* Info text above beneficiaries list - only for recharge products */}
          {this.strategy.showRechargeInfo && (
            <div className="info-text-container">
              <p className="info-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle " viewBox="0 0 16 16" style={{margin: "5px"}}>
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                </svg>
                N'hésitez pas à remplacer la valeur par défaut ( exp : 165 dt) par le montant qui vous convient
              </p>
            </div>
          )}
            
          {beneficiaries.filter((beneficiary)=>beneficiary.status==""+(+desactive)).map((value, index) => {
            return (
              <CardDetail
                value={value}
                key={index}
                index={index}
                uid={value.cardNumber}
                desactive= {desactive}
                productId={product.id}
                showRechargeField={this.strategy.showRechargeField}
                handleChange={(e, i) => this.addBeneficiaries(e, i)}
                handleRemove={(e, i) => this.removeNewBeneficiary(e, i)}
                handleSelect={(e,i) => this.selectBeneficiaries(e,i)}
                handleDisable={(e,i) => this.disableBeneficiaries(e,i)}
              />


            );

          })}
        </div>


        <div className="product-add-to-cart">
          <div className="add green_btn">
            <button type="submit" onClick={() => this.addToCart()}>
              Commander
            </button>
          </div>
        </div>
        <CartPopup Produit={this.state.product} Price={this.state.price} Quantity={this.state.quantity} setOpen={() => this.setOpen()} open={this.state.open} />
      </div>
    );
  }
}

export default Card;
